import { createAction, props } from '@ngrx/store'
import { Channel, ExpenseView, Rental } from '@tokeet-frontend/tv3-platform'
import { RentalDialogTab } from '@tv3/containers/rentals/overlays/rental-overlay/rental-overlay.component'
import { Invoice, InvoiceTypes } from '@tokeet-frontend/invoices'
import { AddInquiryDialogParams } from '@tv3/interfaces/dialogs/add-inquiry-dialog-params'
import { HoldDialogInputs } from '@tv3/containers/calendar/hold/hold-dialog/hold-dialog.component'
import { EditRateDialogInput } from '@tv3/containers/rates/edit-rate-dialog/edit-rate-dialog.component'
import { ExtraView } from '@tokeet-frontend/extras'
import { ChargeResponse } from '@tokeet-frontend/charges'
import { LosDiscountView } from '@tokeet-frontend/los-discount'
import { DiscountCode } from '@tokeet-frontend/discount-codes'
import { VendorResponse } from '@tokeet-frontend/vendors'
import { Template, TemplateType } from '@tokeet-frontend/templates'
import { BookingFormulaResponse } from '@tokeet-frontend/booking-formula'
import { AccountRatesDialogInput } from '@tv3/containers/rates/account-rates-dialog/account-rates-dialog.component'
import { MinStayAutomationDialogInput } from '@tv3/containers/rates/min-stay-automations/automation-dialog/min-stay-automation-dialog.component'
import { GapNightAutomationDialogInput } from '@tv3/containers/rates/gap-night-automations/automation-dialog/gap-night-automation-dialog.component'
import { ChannelAutomationDialogInput } from '@tv3/containers/rates/channel-automations/automation-dialog/channel-automation-dialog.component'
import { LastMinuteAutomationDialogInput } from '@tv3/containers/rates/last-minute-automations/automation-dialog/last-minute-automation-dialog.component'
import { ApproveDraftTasksDialogParams } from '@tv3/containers/tasks/approve-draft-tasks-dialog/approve-draft-tasks-dialog.component'
import { Connection } from '../connection/connection.model'
import { ConnectionView } from '../connection/connection.view'
import { InventoryView } from '@tokeet-frontend/inventories'
import { WebsiteTypes } from '../website/website.model'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { BookingAdditionalDataTab } from '@tv3/containers/inquiries/overlays/inquiry-overlay/additional-booking-data/tabs'
// Invoice
export const OpenInvoiceOverlay = createAction(
  '[Overlay] Open Invoice',
  props<{ invoiceId: string; invoices?: Invoice[] }>()
)
export const OpenAddInvoiceOverlay = createAction(
  '[Overlay] Open Add Invoice',
  props<{ data?: { type?: InvoiceTypes } }>()
)

// Booking
export const OpenInquiryOverlay = createAction(
  '[Overlay] Open Inquiry',
  props<{ inquiryId: string; activeTab?: BookingAdditionalDataTab }>()
)
export const OpenAddInquiryOverlay = createAction(
  '[Overlay] Open Add Inquiry',
  props<{ params: AddInquiryDialogParams }>()
)

// Guest
export const OpenGuestOverlay = createAction('[Overlay] Open Guest', props<{ guestId: string }>())
export const OpenAddGuestDialog = createAction('[Overlay] Open Add Guest')

// Rental
export const OpenAddRentalDialog = createAction('[Overlay] Open Add Rental')
export const OpenAddRentalMiltiDialog = createAction('[Overlay] Open Add Rental Multiple')
export const OpenAddRentalParentChildDialog = createAction(
  '[Overlay] Open Add Rental Parent Child',
  props<{ parentId?: string }>()
)
export const OpenRentalOverlay = createAction(
  '[Overlay] Open Rental',
  props<{ rental?: Rental; rentalId?: string; activeTab?: RentalDialogTab; highlightedImages?: string[] }>()
)

// Inventory
export const OpenInventoryOverlay = createAction('[Overlay] Open Inventory')
export const OpenEditInventoryDialog = createAction(
  '[Overlay] Open Edit Inventory',
  props<{ inventory: InventoryView }>()
)

// Hold
export const OpenAddHoldDialog = createAction('[Overlay] Open Add Hold', props<{ data?: HoldDialogInputs }>())
export const OpenEditHoldDialog = createAction('[Overlay] Open Edit Hold', props<{ data?: HoldDialogInputs }>())

// Task
export const OpenAddTaskDialog = createAction('[Overlay] Open Add Task')
export const OpenEditTaskDialog = createAction('[Overlay] Open Edit Task', props<{ taskId: string }>())

// Expense
export const OpenAddExpenseDialog = createAction('[Overlay] Open Add Expense')
export const OpenEditExpenseDialog = createAction('[Overlay] Open Edit Expense', props<{ expenseId: string }>())

// Rate
export const OpenAddRateDialog = createAction('[Overlay] Open Add Rate', props<{ data?: EditRateDialogInput }>())
export const OpenEditRateDialog = createAction('[Overlay] Open Edit Rate', props<{ data?: EditRateDialogInput }>())
export const OpenGroupRateDialog = createAction(
  '[Overlay] Open Group Rate',
  props<{ data?: AccountRatesDialogInput }>()
)

// Channel
export const OpenAddChannelDialog = createAction('[Overlay] Open Add Channel')
export const OpenAddCustomChannelDialog = createAction('[Overlay] Open Add Custom Channel')

export const OpenImportCalendarDialog = createAction('[Overlay] Open Import Calendar')
export const OpenAddSharingCalendarDialog = createAction('[Overlay] Open Add Sharing Calendar')
export const OpenAddExportCalendarDialog = createAction(
  '[Overlay] Open Add Export Calendar',
  props<{ data?: { channel?: Channel; rental?: Rental } }>()
)

export const OpenChannelDialog = createAction('[Overlay] Open Channel', props<{ data: { channel: Channel } }>())
export const OpenChannelConnectionDialog = createAction(
  '[Overlay] Open Channel Connection',
  props<{ data: { connection: ConnectionView; wizard?: boolean } }>()
)
export const OpenChannelWizardDialog = createAction(
  '[Overlay] Open Channel Wizard',
  props<{ data: { channel: Channel } }>()
)
export const OpenChannelConnectionWizardDialog = createAction(
  '[Overlay] Open Channel Connection Wizard',
  props<{ data: { channel: Channel; connection: Connection } }>()
)

// Extra
export const OpenAddExtraDialog = createAction('[Overlay] Open Add Extra')
export const OpenEditExtraDialog = createAction('[Overlay] Open Edit Extra', props<{ extra: ExtraView }>())

// Website
export const OpenAddWebsiteDialog = createAction(
  '[Overlay] Open Add Website',
  props<{ data: { type: WebsiteTypes } }>()
)

// Incident
export const OpenAddIncidentDialog = createAction('[Overlay] Open Add Incident')
export const OpenEditIncidentDialog = createAction('[Overlay] Open Edit Incident', props<{ incidentId: string }>())

export const OpenDraftTasksApprovalDialog = createAction(
  '[Overlay] Open Draft Tasks Approval',
  props<{ data?: ApproveDraftTasksDialogParams }>()
)

// Charge
export const OpenAddChargeDialog = createAction('[Overlay] Open Add Charge')
export const OpenEditChargeDialog = createAction('[Overlay] Open Edit Charge', props<{ charge: ChargeResponse }>())

// LOS discount
export const OpenAddLosDiscountDialog = createAction('[Overlay] Open Add LOS Discount')
export const OpenEditLosDiscountDialog = createAction(
  '[Overlay] Open Edit LOS Discount',
  props<{ losDiscount: LosDiscountView }>()
)

// Discount Code
export const OpenAddDiscountCodeDialog = createAction('[Overlay] Open Add Discount Code')
export const OpenEditDiscountCodeDialog = createAction(
  '[Overlay] Open Edit Discount Code',
  props<{ discountCode: DiscountCode }>()
)

// Vendor
export const OpenAddVendorDialog = createAction('[Overlay] Open Add Vendor')
export const OpenEditVendorDialog = createAction('[Overlay] Open Edit Vendor', props<{ vendor: VendorResponse }>())

// Template
export const OpenAddTemplateDialog = createAction(
  '[Overlay] Open Add Template',
  props<{ data?: { type?: TemplateType } }>()
)
export const OpenEditTemplateDialog = createAction('[Overlay] Open Edit Template', props<{ template: Template }>())

// Device
export const OpenAddDeviceDialog = createAction('[Overlay] Open Add Device')

// Payment Gateway
export const OpenAddPaymentGatewayDialog = createAction('[Overlay] Open Add Payment Gateway')

// Data Feed
export const OpenAddDataFeedDialog = createAction('[Overlay] Open Add Data Feed')

// Email Forwarding
export const OpenAddEmailForwardingDialog = createAction('[Overlay] Open Add Email Forwarding')

// Booking Formula
export const OpenAddBookingFormulaDialog = createAction(
  '[Overlay] Open Add Booking Formula',
  props<{ data?: { channel?: { id: string; name: string } } }>()
)
export const OpenEditBookingFormulaDialog = createAction(
  '[Overlay] Open Edit Booking Formula',
  props<{ bookingFormula: BookingFormulaResponse }>()
)

// Document
export const OpenAddDocumentDialog = createAction('[Overlay] Open Add Document')

// Automation
export const OpenAutomationWizardOverlay = createAction(
  '[Overlay] Open Automation Wizard',
  props<{ data?: { type?: AutomationTypes; event?: AutomationEventTypes } }>()
)
export const OpenTaskAutomationOverlay = createAction('[Overlay] Open Task Automation')
export const OpenMessageAutomationOverlay = createAction('[Overlay] Open Message Automation')
export const OpenBookingAutomationOverlay = createAction('[Overlay] Open Booking Automation')
export const OpenDocumentAutomationOverlay = createAction('[Overlay] Open Document Automation')
export const OpenReviewAutomationOverlay = createAction('[Overlay] Open Review Automation')
export const OpenExpenseAutomationOverlay = createAction('[Overlay] Open Expense Automation')
export const OpenInvoiceAutomationOverlay = createAction('[Overlay] Open Invoice Automation')
export const OpenRateAutomationDialog = createAction(
  '[Overlay] Open Rate Automation',
  props<{ data?: AccountRatesDialogInput }>()
)

export const OpenMinStayAutomationDialog = createAction(
  '[Overlay] Open Min Stay Automation',
  props<{ data?: MinStayAutomationDialogInput }>()
)
export const OpenGapNightAutomationDialog = createAction(
  '[Overlay] Open Gap Night Automation',
  props<{ data?: GapNightAutomationDialogInput }>()
)
export const OpenChannelAutomationDialog = createAction(
  '[Overlay] Open Channel Automation',
  props<{ data?: ChannelAutomationDialogInput }>()
)
export const OpenLastMinuteAutomationDialog = createAction(
  '[Overlay] Open Last Minute Automation',
  props<{ data?: LastMinuteAutomationDialogInput }>()
)
